export default "__VITE_ASSET__Bz7b$5BZ__"